export const PUB_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCnNXAHacGx9dLFkhkaxsBpmVkN
DNgwgvLC0Ot/h5bdfDr41ex1kuZYhYijcumicwqfHiwGrizFT0LLekuKLRfuIm/C
qf7Wtzsv3aBJZg9XZljXSu2mqWdzNeQzIM4828bPQt7zh6Qi9RsxUkB8o7ksX2FF
0k8N7p/az2zcPtLxJQIDAQAB
-----END PUBLIC KEY-----
`;
